import { parseSegments } from '../data/linkDetection.js'

/**
 * RichText — renders user-entered text with bare URLs linkified.
 *
 * Intentionally narrow scope: we don't do markdown, just linkification.
 * Mentions are rendered by the caller (CommentPanel has its own
 * renderTextWithMentions helper that wraps this), so this component
 * stays focused.
 *
 * Props:
 *   text       — the raw string to render
 *   linkColor  — override for the link color (defaults to accent)
 *   children   — optional render-prop: (segments) => ReactNode. Use
 *                 this when you want to post-process text segments
 *                 (e.g., to apply mentions on top of linkification).
 */
export default function RichText({ text, linkColor, children }) {
  const segments = parseSegments(text)

  if (typeof children === 'function') {
    return children(segments)
  }

  return (
    <>
      {segments.map((seg, i) =>
        seg.type === 'url' ? (
          <a
            key={i}
            href={seg.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: linkColor || 'var(--accent)',
              textDecoration: 'underline',
              wordBreak: 'break-all',
            }}
          >
            {seg.value}
          </a>
        ) : (
          <span key={i}>{seg.value}</span>
        )
      )}
    </>
  )
}
